import Link from "next/link";
import { useCartContext } from "@context/cart";
import { toFarsiNumber } from "@utils/digits";
import BasketIcon from "@svg/header/buy";
import { useIsMount } from "@utils/helpers";
import { useEffect, useState } from "react";
import { useLayoutContext } from "@context/layout";

const CartButton = () => {
  const { userData } = useLayoutContext();
  const { cart } = useCartContext();
  const [cartItem, setCart] = useState(cart);
  const isLogin = userData?.is_login;
  const isMount = useIsMount();

  useEffect(() => {
    if (!isMount) setCart(cart);
  }, [cart]);

  const cartCountLabel = cartItem.length
    ? `سبد خرید، ${toFarsiNumber(String(cartItem.length))} مورد`
    : "سبد خرید";

  return (
    <Link
      href={isLogin ? "/checkout" : "/cart"}
      prefetch={false}
      aria-label={cartCountLabel}
      className="relative mx-3 md:mx-1 block"
    >
      <BasketIcon />
      {Boolean(cartItem.length) && (
        <span
          aria-hidden="true"
          className="absolute flex items-center justify-center px-2 -bottom-px -right-1.5 w-4 h-4 pt-0.5 rounded-full text-white text-center bg-[#3064C0] font-bold text-[11px] border-white border-[1.5px]"
        >
          {toFarsiNumber(String(cartItem.length))}
        </span>
      )}
    </Link>
  );
};

export default CartButton;
